export default "__VITE_ASSET__Cckod8me__"